/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as TradeRouteImport } from './routes/trade'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RiskRouteImport } from './routes/risk'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'

const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeRoute = TradeRouteImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskRoute = RiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/trade': typeof TradeRoute
  '/wallet': typeof WalletRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/trade': typeof TradeRoute
  '/wallet': typeof WalletRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/trade': typeof TradeRoute
  '/wallet': typeof WalletRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/cookies'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/privacy'
    | '/risk'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/trade'
    | '/wallet'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/cookies'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/privacy'
    | '/risk'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/trade'
    | '/wallet'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/cookies'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/privacy'
    | '/risk'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/trade'
    | '/wallet'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  CookiesRoute: typeof CookiesRoute
  DashboardRoute: typeof DashboardRoute
  DemoRoute: typeof DemoRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RiskRoute: typeof RiskRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  TradeRoute: typeof TradeRoute
  WalletRoute: typeof WalletRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade': {
      id: '/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof TradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk': {
      id: '/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof RiskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  CookiesRoute: CookiesRoute,
  DashboardRoute: DashboardRoute,
  DemoRoute: DemoRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RiskRoute: RiskRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  TradeRoute: TradeRoute,
  WalletRoute: WalletRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
